<template>
  <div class="header mb-2">
    <div class="navbarWrapper">
      <div class="grid surface-0 shadow-2 pt-2 pb-2">
        <div class="col-4 pt-0 pb-0 text-start">
          <RouterLink to="/">
            <img src="../assets/logo.png" width="50" />
          </RouterLink>
        </div>
        <div class="col-8 pt-0 pb-0">
          <div class="card flex justify-content-end align-items-center">
            <span class="mr-2 font-bold">{{ this.userName }}</span>
            <input
              v-show="isSearchVisible"
              @input="
                ($event) => {
                  emit('on-search');
                  emit('update:modelValue', $event.target.value);
                }
              "
              type="search"
              :value="modelValue"
              placeholder="Mobile no. / Patient's name"
              class="p-inputtext p-component w-full"
            />
            <Button
              @click="handleLogout"
              icon="pi pi-sign-out"
              severity="danger"
              text
              aria-label="Logout"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { defineProps, defineEmits } from "vue";
defineProps({
  isSearchVisible: Boolean,
  modelValue: String,
});

const emit = defineEmits(["update:modelValue", "on-search"]);

const router = useRouter();
const store = useStore();

const handleLogout = () => {
  store.dispatch("auth/logout");
  router.push("/");
};

// const accountItems = ref([
//   {
//     label: "Change Password",
//     icon: "pi pi-box",
//   },
//   {
//     label: "Logout",
//     icon: "pi pi-box",
//     command: handleLogout,
//   },
// ]);
</script>
